import Translate from "@service/Translate";
import pageNotFound from '@assets/images/page-not-found.png';
import  { FC } from "react";
import Button from "@components/general/form/Button";
import { useHistory } from "react-router";
import { Path } from "@common/constans";

export const NotFound: FC = () => {
  const tr = Translate.tr;
  const { push } = useHistory();

  return (
    <div className="not-found-page">
      <div className="container flex">
        <div className="content-section">
          <div className="content-not-found-404">{tr("page_not_found_404")}</div>
          <div className="content-not-found">{tr("page_msg_not_found")}</div>
          <div className="content-not-found-desc">{tr("page_msg_not_found_remark")}</div>
          <div className="img-res-section"><img src={pageNotFound} alt="Page not found" /></div>
          <div className="button-group">
            <Button text={tr("mahan_air_web_site")} variant="outlined" color="primary" onClick={() => push(Path.Home)} />
            <Button text={tr("btn_ticket_reserve")} variant="outlined" color="primary" onClick={() => push(Path.Booking.Home)} />
          </div>
        </div>
        <div className="img-section"><img src={pageNotFound} alt="Page not found" /></div>
      </div>
    </div>
  );
}
